import { AxiosError } from 'axios';
import { POST_VALIDATE_PAYMENT_TOKEN } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  onSettled?: () => void;
}

export const usePostValidatePaymentToken = ({ onSuccess, onError, onSettled }: Input = {}) => {
  const postValidatePaymentToken = async (token: string) => {
    const res = await axiosClient.post<void>(POST_VALIDATE_PAYMENT_TOKEN(token));

    return res.data;
  };

  return useCustomMutation(postValidatePaymentToken, {
    onSuccess,
    onError,
    onSettled,
  });
};
